'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _underscore = require('../../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../../core/Functions');

var _deprecated = require('../../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BLANK_REGEX = /^\s*$/;

var PERCENTAGE_REGEX = /%$/;

var NUMBER_TYPES = {
  DECIMAL: 'decimal',
  CURRENCY: 'currency',
  PERCENTAGE: 'percentage'
};

function formatCurrency(value, currency) {
  var symbolData = _I18n2.default.currencySymbols[currency];
  var currencySymbol = symbolData ? symbolData.symbol_native : '';
  var defaultPrecision = symbolData ? symbolData.decimal_digits : 2;
  var currencyOptions = {
    unit: currencySymbol,
    precision: defaultPrecision
  };

  return _I18n2.default.formatCurrency(value, currencyOptions);
}

function parseCurrency(valueToParse, currency) {
  var currencySymbol = _I18n2.default.currencySymbols[currency].symbol_native;
  var currencySymbolRegex = new RegExp('' + currencySymbol.replace(/\W/g, '\\$&'), 'g');
  return valueToParse.replace(currencySymbolRegex, '');
}

function formatPercentage(value) {
  return _I18n2.default.formatPercentage(value, { precision: value % 1 === 0 ? 0 : 2 });
}

function parsePercentage(valueToParse) {
  return valueToParse.replace(PERCENTAGE_REGEX, '');
}

var UIAbstractNumberInput = _react2.default.createClass({
  displayName: 'UIAbstractNumberInput',

  propTypes: {
    children: _react.PropTypes.func.isRequired,
    currency: (0, _deprecated2.default)(_react.PropTypes.oneOf(Object.keys(_I18n2.default.currencySymbols)), {
      message: 'UINumberInput: The `currency` prop has been deprecated. Use UICurrencyInput instead.',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6434',
      key: 'UINumberInput-current-prop'
    }),
    error: _react.PropTypes.bool,
    formatStyle: _react.PropTypes.oneOf(Object.keys(NUMBER_TYPES).map(function (k) {
      return NUMBER_TYPES[k];
    })),
    formatter: _react.PropTypes.func,
    parser: _react.PropTypes.func,
    onBlur: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    onFocus: _react.PropTypes.func,
    onKeyUp: _react.PropTypes.func,
    value: _react.PropTypes.number,
    min: _react.PropTypes.number,
    max: _react.PropTypes.number
  },

  getInitialState: function getInitialState() {
    var _props = this.props,
        currency = _props.currency,
        value = _props.value,
        formatStyle = _props.formatStyle,
        formatter = _props.formatter;

    return this.getStateOnValueReset({
      currency: currency,
      value: value,
      formatStyle: formatStyle,
      formatter: formatter
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props2 = this.props,
        currency = _props2.currency,
        value = _props2.value,
        formatStyle = _props2.formatStyle,
        formatter = _props2.formatter;
    // Uses this flag to determine if the last change was triggered by the `ESC` key.
    // This logic is separate from the following logic since value and nextProps.value
    // could be equal, and you would still want this reset to trigger. (1000 vs 1,000)

    if (this.escKeyUpTriggered) {
      this.setState(this.getStateOnValueReset({
        currency: nextProps.currency,
        value: nextProps.value,
        formatStyle: nextProps.formatStyle,
        formatter: nextProps.formatter
      }));
      this.escKeyUpTriggered = false;
      return;
    }

    // Ignore changes from one invalid value (NaN) to another
    var valueChanged = value !== nextProps.value && !((0, _underscore.isNaN)(value) && (0, _underscore.isNaN)(nextProps.value));
    var formatStyleChanged = formatStyle !== nextProps.formatStyle;
    var formatterChanged = formatter !== nextProps.formatter;
    if (currency !== nextProps.currency || valueChanged || formatStyleChanged || formatterChanged) {
      if (!this.isTyping) {
        this.setState(this.getStateOnValueReset({
          currency: nextProps.currency,
          value: nextProps.value,
          formatStyle: nextProps.formatStyle,
          formatter: nextProps.formatter
        }));
      }
    }
  },
  getStateOnValueReset: function getStateOnValueReset(_ref) {
    var currency = _ref.currency,
        value = _ref.value,
        formatStyle = _ref.formatStyle,
        formatter = _ref.formatter;

    var isValid = this.getValueIsValid({ value: value });
    return {
      isValid: isValid,
      lastValidValue: isValid ? value : null,
      displayedValue: this.getFormattedNumber({
        currency: currency,
        value: value,
        formatStyle: formatStyle,
        formatter: formatter
      })
    };
  },
  getValueIsValid: function getValueIsValid(_ref2) {
    var value = _ref2.value;

    return value == null || value === '' || !(0, _underscore.isNaN)(_I18n2.default.parseNumber(value));
  },
  getFormattedNumber: function getFormattedNumber(_ref3) {
    var currency = _ref3.currency,
        value = _ref3.value,
        formatStyle = _ref3.formatStyle,
        formatter = _ref3.formatter;

    if (formatter) {
      var formatterResult = formatter(value);
      if (typeof formatterResult !== 'string') {
        _devLogger2.default.warn({
          message: 'UIAbstractNumberInput: Expected `formatter(value)` to return a string, but ' + ('it returned `' + formatterResult + '`.'),
          key: 'UIAbstractNumberInput: bad formatter result'
        });
      } else {
        return formatterResult;
      }
    }

    if (value == null || value === '') {
      return '';
    }

    if (!this.getValueIsValid({ value: value })) {
      return value;
    }

    if (formatStyle === NUMBER_TYPES.PERCENTAGE) {
      return formatPercentage(value);
    }

    // `currency` implies formatStyle === NUMBER_TYPES.CURRENCY
    // we're not strict about this for backwards-compatibility
    if (currency && formatStyle !== NUMBER_TYPES.DECIMAL) {
      return formatCurrency(value, currency);
    }

    return _I18n2.default.formatNumber(value);
  },
  getParsedValue: function getParsedValue(_ref4) {
    var currency = _ref4.currency,
        rawValue = _ref4.rawValue,
        formatStyle = _ref4.formatStyle,
        parser = _ref4.parser;

    if (parser) {
      var parserResult = parser(rawValue);
      if (parserResult != null && typeof parserResult !== 'number') {
        _devLogger2.default.warn({
          message: 'UIAbstractNumberInput: Expected `parser(value)` to return a number or null, but ' + ('it returned `' + parserResult + '`.'),
          key: 'UIAbstractNumberInput: bad parser result'
        });
      } else {
        return parserResult;
      }
    }

    var valueToParse = rawValue;
    // Ignore currency characters when parsing input
    if (currency && formatStyle !== NUMBER_TYPES.DECIMAL) {
      valueToParse = parseCurrency(valueToParse, currency);
    }

    // Ignore % character when parsing input
    if (formatStyle === NUMBER_TYPES.PERCENTAGE) {
      valueToParse = parsePercentage(valueToParse);
    }

    var parsedValue = BLANK_REGEX.test(valueToParse) ? null : _I18n2.default.parseNumber(valueToParse);

    return parsedValue;
  },
  handleChange: function handleChange(evt) {
    // Trigger onChange with the numeric value, not the raw string
    var _props3 = this.props,
        onChange = _props3.onChange,
        currency = _props3.currency,
        value = _props3.value,
        formatStyle = _props3.formatStyle,
        min = _props3.min,
        max = _props3.max,
        parser = _props3.parser;

    var rawValue = evt.target.value;
    this.setState({
      displayedValue: rawValue
    });

    // Prevent formatting while the user is typing
    this.isTyping = true;

    var parsedValue = this.getParsedValue({
      currency: currency,
      rawValue: rawValue,
      formatStyle: formatStyle,
      parser: parser
    });
    if (value != null && parsedValue == null) {
      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent2.default)(null));
      return;
    }

    if (parsedValue !== value && !(0, _underscore.isNaN)(parsedValue)) {
      var fencedMin = min == null ? parsedValue : Math.max(parsedValue, min);
      var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max);

      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent2.default)(fencedValue));
    }
  },
  handleBlur: function handleBlur(evt) {
    var onBlur = this.props.onBlur;


    this.handleConfirmedInput();
    this.isTyping = false;

    (0, _Functions.callIfPossible)(onBlur, evt);
  },
  handleFocus: function handleFocus(evt) {
    var onFocus = this.props.onFocus;
    // If displayedValue is invalid, clear it on focus

    var isValid = this.state.isValid;

    if (!isValid) {
      this.setState({
        isValid: true,
        displayedValue: ''
      });
    }
    (0, _Functions.callIfPossible)(onFocus, evt);
  },
  handleConfirmedInput: function handleConfirmedInput() {
    // Format whatever the user typed for display (e.g. "1234" -> "1,234")
    var _props4 = this.props,
        currency = _props4.currency,
        formatStyle = _props4.formatStyle,
        formatter = _props4.formatter,
        value = _props4.value;
    var lastValidValue = this.state.lastValidValue;

    var isValid = this.getValueIsValid({ value: value });

    this.setState({
      isValid: isValid,
      lastValidValue: lastValidValue,
      displayedValue: this.getFormattedNumber({
        currency: currency,
        value: value,
        formatStyle: formatStyle,
        formatter: formatter
      })
    });
  },
  handleKeyUp: function handleKeyUp(evt) {
    var _props5 = this.props,
        onChange = _props5.onChange,
        onKeyUp = _props5.onKeyUp,
        value = _props5.value;
    var lastValidValue = this.state.lastValidValue;

    // If ESC is pressed, reset to lastValidValue

    if (evt.key === 'Escape' && lastValidValue !== value) {
      (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent2.default)(lastValidValue));
      this.escKeyUpTriggered = true;
    }
    // If Enter is pressed, format the value
    if (evt.key === 'Enter' && lastValidValue !== value) {
      this.handleConfirmedInput();
    }

    (0, _Functions.callIfPossible)(onKeyUp, evt);
  },
  render: function render() {
    var _props6 = this.props,
        children = _props6.children,
        __currency = _props6.currency,
        error = _props6.error,
        __formatter = _props6.formatter,
        __parser = _props6.parser,
        __onChange = _props6.onChange,
        __value = _props6.value,
        __formatStyle = _props6.formatStyle,
        rest = _objectWithoutProperties(_props6, ['children', 'currency', 'error', 'formatter', 'parser', 'onChange', 'value', 'formatStyle']);

    (0, _invariant2.default)(typeof children === 'function', '%s: this.props.children must be a function but got %s', 'UIAbstractNumberInput', children);
    return children(_extends({}, rest, {
      'aria-invalid': typeof error === 'boolean' ? error : !this.state.isValid,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onKeyUp: this.handleKeyUp,
      value: this.state.displayedValue
    }));
  }
});

UIAbstractNumberInput.defaultProps = {
  error: undefined, // needed to override UITextInput's default
  formatStyle: undefined
};

exports.default = UIAbstractNumberInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/abstract/UIAbstractNumberInput.js
// module id = 668
// module chunks = 3 4